import * as d3 from "d3"

const ANIMATION_DURATION = 200
const TOOLTIP_WIDTH = 30
const TOOLTIP_HEIGHT = 30
const bg_color = '#377BB5'
const THEME_COLORS = [
  '#2F4D6B', '#416E9B', '#6390B1', '#689FCC', '#57B6F5',
  '#6AB6B3', '#00C5B1', '#E9604B', '#976A3D', '#60A31C',
  '#558DC6', '#C8407B', '#258C94', '#E9A85C', '#714A48',
  '#78765E', '#959481', '#994D23', '#'
]
const MARGIN = {top: 0, right: 0, bottom: 0, left: 0}
const ns = {}

ns.create = function(el, data, props) {
  var svg = d3.select(el)
      .append('svg')
      .attr('class', 'd3')
      .attr('version', 1.1)
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')

  svg.append("path").attr('fill', function(d) { return 'white' })

  svg.append('g').attr('class', 'line-point')

  this.drawChart(el, data, props)
}

ns.update = function(el, data, props) {
  this.drawChart(el, data, props)
}

ns.drawChart = function(el, data, props) {
  data = _.map(data, (num, i) => ({value: num, id: i}))
  var {height} = props
  var svg = d3.select(el).select('svg').attr('width', '100%')
  var chart = svg.select('g.chart')
  var computed_width = svg.node().getBoundingClientRect().width

  svg
    .attr('width', computed_width + 'px')
    .attr('height', height + 'px')


  var inner_width = computed_width - MARGIN.left - MARGIN.right
  var inner_height = height - MARGIN.top - MARGIN.bottom
  var x = d3.scaleLinear()
    .domain(d3.extent(data, function(d) { return d.id }))
    .range([0, inner_width])
  var y = d3.scaleLinear()
    .domain([0, d3.max(data, function(d) { return d.value })])
    .range([inner_height, 0])

  var area = d3.area()
    .x(function(d) { return x(d.id) })
    .y0(inner_height)
    .y1(function(d) { return y(d.value) })

  // Bind data to circles
  var circles = svg.select('g.line-point')
    .selectAll('circle')
    .data(data)

  // Enter data and append circle nodes
  circles.enter().append('circle')

  // Retired nodes which is no longer existed
  circles.exit().remove()

  // Update circle attributes after old node removed
  circles.attr('r', 4.5)
    .attr('opacity', '1')
    .style('fill', '#2DFFFE')

  var path = svg.select("path")
      .datum(data)

  path.transition()
      .duration(ANIMATION_DURATION*2)
      .attr("class", "area")
      .attr("d", area)

  circles.transition()
    .duration(ANIMATION_DURATION*4)
    .attr('cx', function(d) { return x(d.id) })
    .attr('cy', function(d) { return y(d.value) })
}

ns.destroy = function(el) {

}

module.exports = ns



/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/d3_area_chart.js
 **/